import { FBXLoader, GLTFLoader, OBJLoader } from 'three-stdlib';

// Erstelle Loader-Instanzen (werden wiederverwendet)
let gltfLoader = null;
let fbxLoader = null;
let objLoader = null;

const getGLTFLoader = () => {
    if (!gltfLoader) {
        gltfLoader = new GLTFLoader();
        // DRACO Loader kann hier hinzugefügt werden falls benötigt
        // Für jetzt ohne DRACO, da es zusätzliche Dependencies benötigt
    }
    return gltfLoader;
};

const getFBXLoader = () => {
    if (!fbxLoader) {
        fbxLoader = new FBXLoader();
    }
    return fbxLoader;
};

const getOBJLoader = () => {
    if (!objLoader) {
        objLoader = new OBJLoader();
    }
    return objLoader;
};

const loadModel = (url, fileType, modelRef) => {
    return new Promise((resolve, reject) => {
        if (!url) {
            reject(new Error('No model URL provided'));
            return;
        }

        // Bestimme Dateityp automatisch aus URL falls nicht angegeben
        let actualFileType = fileType;
        if (!actualFileType) {
            // Entferne Query-Parameter und Hash aus URL
            const cleanUrl = url.split('?')[0].split('#')[0];
            const extension = cleanUrl.toLowerCase().split('.').pop();
            
            if (extension === 'glb') {
                actualFileType = 'glb';
            } else if (extension === 'gltf') {
                actualFileType = 'gltf';
            } else if (extension === 'fbx') {
                actualFileType = 'fbx';
            } else if (extension === 'obj') {
                actualFileType = 'obj';
            } else {
                // Fallback: Versuche GLTF, aber mit Warnung
                console.warn(`Unknown file extension: ${extension}, trying GLTF loader`);
                actualFileType = 'gltf';
            }
        }

        let loader;
        switch (actualFileType) {
            case 'fbx':
                loader = getFBXLoader();
                break;
            case 'gltf':
            case 'glb':
                // GLTFLoader kann sowohl GLTF als auch GLB laden
                loader = getGLTFLoader();
                break;
            case 'obj':
                loader = getOBJLoader();
                break;
            default:
                loader = getOBJLoader();
        }

        // Progress callback (optional)
        const onProgress = (progress) => {
            if (progress.lengthComputable) {
                const percentComplete = (progress.loaded / progress.total) * 100;
                console.log(`Model loading: ${percentComplete.toFixed(2)}%`);
            }
        };

        // Error callback
        const onError = (error) => {
            console.error('An error occurred while loading the model:', error);
            console.error('URL:', url);
            console.error('File type:', actualFileType);
            
            // Verbesserte Fehlermeldung
            let errorMessage = 'Fehler beim Laden des Modells';
            if (error.message && error.message.includes('JSON')) {
                errorMessage = `Die Datei scheint kein gültiges ${actualFileType.toUpperCase()}-Format zu sein. Bitte überprüfen Sie die Datei.`;
            } else if (error.message) {
                errorMessage = error.message;
            }
            
            reject(new Error(errorMessage));
        };

        // Success callback
        const onLoad = (loadedModel) => {
            try {
                if (actualFileType === 'gltf' || actualFileType === 'glb') {
                    modelRef.current = loadedModel.scene;  // GLTF/GLB hat .scene
                } else {
                    modelRef.current = loadedModel;  // FBX/OBJ ist direkt das Modell
                }
                resolve();
            } catch (error) {
                console.error('Error processing loaded model:', error);
                reject(error);
            }
        };

        // Lade das Modell
        try {
            loader.load(url, onLoad, onProgress, onError);
        } catch (error) {
            console.error('Error starting model load:', error);
            reject(error);
        }
    });
};

export { loadModel };

